import { render, staticRenderFns } from "./Contact-center.vue?vue&type=template&id=3061b0a0"
import script from "./Contact-center.vue?vue&type=script&lang=js"
export * from "./Contact-center.vue?vue&type=script&lang=js"
import style0 from "./Contact-center.vue?vue&type=style&index=0&id=3061b0a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports